<template>
  <div class="explainer-guide" ref="explainer">
    <div class="white-backdrop"></div>
    <header-buttons :style="{'z-index': isButtonsHighlighted}" />
    <sta-fake-start-screen :style="{'z-index': isAppHighlighted}" />
    <fake-step-guide :style="{'z-index': isGuideHighlighted}" />
    <div class="blue-backdrop"></div>
    <div class="explainer-tooltip" :style="tip.style">
      <div :class="{'tip-content': true, 'visible': !isTransition}">
        <div class="tip-number">
          {{ tipText }} {{ currentTip + 1 }}/{{ tips.length }}
        </div>
        <div class="tip-text">
          {{ tip.text }}
        </div>
        <div class="tip-action">
          <button v-html="tip.buttons[0]" @click="nextTip(true)" v-if="tip.buttons.length === 1" class="single-btn"></button>
          <div v-else>
            <button v-html="text" @click="nextTip(false, index)" v-for="(text, index) in tip.buttons" :key="index"></button>
          </div>
        </div>
        <div class="tip-nav">
          <div v-for="n in tips.length"
            :class="{'tip-circle': true, 'active': currentTip + 1 === n}"
            :key="n"
            @click="currentTip = n - 1"
          ></div>
        </div>
      </div>
    </div>
    <div :class="{'explainer-arrow': true, 'visible': !isTransition}" :style="tip.arrowStyle"></div>
  </div>
</template>

<script>
import FakeStepGuide from './FakeStepGuide';
import HeaderButtons from './../elements/HeaderButtons';
import staFakeStartScreen from './../elements/sta/screens/FakeStartScreen';

import { EVENT_EXPLAINER_DONE } from '@/constants';
import { mapActions } from 'vuex';

export default {
  name: 'StaExplainerGuide',
  components: {
    FakeStepGuide,
    HeaderButtons,
    staFakeStartScreen,
  },
  data() {
    return {
      currentTip: 0,
      isTransition: false,
      timer: null,
      tipsArr: [
        [
          {
            text: 'Start your demo by selecting the first use case you’d like to learn more about.',
            buttons: [
              'OK! Next One <i class="fa fa-caret-right" aria-hidden="true"></i>',
            ],
            style: {
              top: '5px',
              left: '452px',
            },
            arrowStyle: {
              top: '385px',
              left: '723px',
              width: '243px',
              height: '178px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-1.png)',
            },
          },
          {
            text: 'You will see Netwrix Access Analyzer in action on this part of your screen.',
            buttons: [
              'Back',
              'Next One',
            ],
            style: {
              top: '51px',
              left: '1155px',
            },
            arrowStyle: {
              top: '401px',
              left: '1087px',
              width: '243px',
              height: '177px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-2.png)',
            },
          },
          {
            text: 'At any time, you can request pricing information or schedule a 1-1 demo with one of our engineers by clicking these buttons.',
            buttons: [
              'Back',
              'Got It',
            ],
            style: {
              top: '68px',
              left: '661px',
            },
            arrowStyle: {
              top: '22px',
              left: '1035px',
              width: '178px',
              height: '243px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-3.png)',
            },
          },
        ],
        [
          {
            text: 'Commencez votre démo en sélectionnant la première utilisation sur laquelle vous aimeriez en savoir plus',
            buttons: [
              'Ok ! Suivant <i class="fa fa-caret-right" aria-hidden="true"></i>',
            ],
            style: {
              top: '5px',
              left: '452px',
            },
            arrowStyle: {
              top: '385px',
              left: '723px',
              width: '243px',
              height: '178px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-1.png)',
            },
          },
          {
            text: 'Vous verrez Netwrix Access Analyzer en action sur cette partie de votre écran',
            buttons: [
              'Retour',
              'Suivant',
            ],
            style: {
              top: '51px',
              left: '1155px',
            },
            arrowStyle: {
              top: '401px',
              left: '1087px',
              width: '243px',
              height: '177px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-2.png)',
            },
          },
          {
            text: "Vous pouvez à tout moment solliciter des informations sur nos tarifs ou demander une démo individuelle avec l'un de nos ingénieurs en cliquant sur ces boutons",
            buttons: [
              'Retour',
              "J'ai compris",
            ],
            style: {
              top: '68px',
              left: '661px',
            },
            arrowStyle: {
              top: '22px',
              left: '1035px',
              width: '178px',
              height: '243px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-3.png)',
            },
          },
        ],
        [
          {
            text: 'Starten Sie Ihre Demo, indem Sie das erste Anwendungsszenario auswählen, über das Sie mehr erfahren möchten',
            buttons: [
              'Okay! Nächster Tipp <i class="fa fa-caret-right" aria-hidden="true"></i>',
            ],
            style: {
              top: '5px',
              left: '452px',
            },
            arrowStyle: {
              top: '385px',
              left: '723px',
              width: '243px',
              height: '178px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-1.png)',
            },
          },
          {
            text: 'In diesem Bereich Ihres Bildschirms sehen Sie Netwrix Access Analyzer in Aktion',
            buttons: [
              'Zurück',
              'Nächster Tipp',
            ],
            style: {
              top: '51px',
              left: '1155px',
            },
            arrowStyle: {
              top: '401px',
              left: '1087px',
              width: '243px',
              height: '177px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-2.png)',
            },
          },
          {
            text: 'Sie können jederzeit Informationen zu Preisen anfordern oder einen Termin für eine persönliche Demo mit einem unserer Engineers vereinbaren, indem Sie auf diese Schaltflächen klicken.',
            buttons: [
              'Zurück',
              'Verstanden',
            ],
            style: {
              top: '68px',
              left: '661px',
            },
            arrowStyle: {
              top: '22px',
              left: '1035px',
              width: '178px',
              height: '243px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-3.png)',
            },
          },
        ],
        [
          {
            text: "Inizia la tua demo selezionando il primo caso d'uso su cui desideri saperne di più",
            buttons: [
              'Ok! Avanti <i class="fa fa-caret-right" aria-hidden="true"></i>',
            ],
            style: {
              top: '5px',
              left: '452px',
            },
            arrowStyle: {
              top: '385px',
              left: '723px',
              width: '243px',
              height: '178px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-1.png)',
            },
          },
          {
            text: 'Vedrai Netwrix Access Analyzer in azione su questa parte dello schermo.',
            buttons: [
              'Indietro',
              'Avanti',
            ],
            style: {
              top: '51px',
              left: '1155px',
            },
            arrowStyle: {
              top: '401px',
              left: '1087px',
              width: '243px',
              height: '177px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-2.png)',
            },
          },
          {
            text: 'Potrai richiedere in qualsiasi momento maggiori informazioni sui prezzi o fissare una demo 1-1 con uno dei nostri esperti semplicemente cliccando su questi pulsanti.',
            buttons: [
              'Zurück',
              'Verstanden',
            ],
            style: {
              top: '68px',
              left: '661px',
            },
            arrowStyle: {
              top: '22px',
              left: '1035px',
              width: '178px',
              height: '243px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-3.png)',
            },
          },
        ],
        [],
        [
          {
            text: 'Empieza la demo seleccionando el primer caso de uso sobre el que te gustaría obtener más información.',
            buttons: [
              '¡De acuerdo! Siguiente <i class="fa fa-caret-right" aria-hidden="true"></i>',
            ],
            style: {
              top: '5px',
              left: '452px',
            },
            arrowStyle: {
              top: '385px',
              left: '723px',
              width: '243px',
              height: '178px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-1.png)',
            },
          },
          {
            text: 'En esta parte de tu pantalla verás en acción Netwrix Access Analyzer.',
            buttons: [
              'Atrás',
              'Siguiente',
            ],
            style: {
              top: '51px',
              left: '1155px',
            },
            arrowStyle: {
              top: '401px',
              left: '1087px',
              width: '243px',
              height: '177px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-2.png)',
            },
          },
          {
            text: 'En cualquier momento podrás solicitar información sobre precios o agendar una demo 1 a 1 con uno de nuestros ingenieros, haciendo clic sobre estos botones.',
            buttons: [
              'Atrás',
              'Entendido',
            ],
            style: {
              top: '68px',
              left: '661px',
            },
            arrowStyle: {
              top: '22px',
              left: '1035px',
              width: '178px',
              height: '243px',
              backgroundImage: 'url(//img.netwrix.com/elements/onlineDemo/arrow-tip-3.png)',
            },
          },
        ],
      ],
    };
  },
  watch: {
    currentTip() {
      this.isTransition = true;
    },
    isTransition(newState) {
      if (newState === true) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.isTransition = false;
        }, 400);
      }
    },
  },
  computed: {
    tips() {
      // first index - language in future
      return this.tipsArr[0];
    },
    tip() {
      return this.tips[this.currentTip];
    },
    tipText() {
      return 'Tip';
    },
    isGuideHighlighted() {
      return this.currentTip === 0 ? 6 : 4;
    },
    isAppHighlighted() {
      return this.currentTip === 1 ? 6 : 4;
    },
    isButtonsHighlighted() {
      return this.currentTip === 2 ? 6 : 4;
    },
  },
  methods: {
    ...mapActions('app', ['setLeftSpacer', 'setRightSpacer']),
    ...mapActions('staApp', ['change', 'setBreadcrumbs']),
    nextTip(isSingle, type) {
      if (isSingle === true || type === 1) {
        if (this.currentTip < this.tips.length - 1) {
          this.currentTip++;
        } else {
          this.$root.$emit(EVENT_EXPLAINER_DONE);
        }
      } else {
        this.currentTip--;
      }
    },
    fadeIn(el, time) {
      el.style.opacity = 0;

      let last = +new Date();
      const tick = function () {
        el.style.opacity = +el.style.opacity + (new Date() - last) / time;
        last = +new Date();

        if (+el.style.opacity < 1) {
          (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }
      };

      tick();
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs.explainer.style.display = 'block';
      this.fadeIn(this.$refs.explainer, 1);
    }, 1000);
  },
  created() {
    this.setLeftSpacer('spacer-sta-application');
    this.setRightSpacer('spacer-sta-application');
  },
};
</script>

<style lang="less" scoped>
  .explainer-guide {
    display: none;
    opacity: 0;
  }

  .white-backdrop, .blue-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
  }

  .blue-backdrop {
    opacity: 0.8;
    background: rgba(4, 76, 129, 0.88);
    z-index: 5;
  }

  .explainer-tooltip {
    position: absolute;
    background-color: #0090ff;
    border-radius: 5px;
    width: 350px;
    z-index: 6;
    padding: 40px 38px 30px 40px;
    transition: top 0.2s, left 0.2s;
    text-align: center;

    .tip-content {
      opacity: 0;

      &.visible {
        opacity: 1;
        transition: opacity 0.2s;
      }
    }

    .tip-number {
      color: #ffffff;
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      line-height: 26px;
      margin-bottom: 24px;
    }

    .tip-text {
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      margin-bottom: 32px;
    }

    .tip-action {
      text-align: center;
      margin-bottom: 22px;

      button {
        width: 120px;
        height: 45px;
        border-radius: 5px;
        border: 2px solid #ffffff;
        background: none;
        color: #ffffff;
        font-size: 15px;
        font-weight: 600;
        line-height: 40px;
        outline: none;

        &:nth-child(1) {
          margin-right: 27px;
        }

        &.single-btn {
          width: 265px;
          margin: 0;
        }
      }
    }

    .tip-nav {
      text-align: center;

      .tip-circle {
        display: inline-block;
        width: 7px;
        height: 7px;
        background-color: #ffffff;
        opacity: 0.4;
        border-radius: 50%;
        margin: 0 4px;
        position: relative;
        cursor: pointer;

        &.active {
          width: 11px;
          height: 11px;
          background-color: #ffffff;
          opacity: 1;
          top: 2px;
        }
      }
    }
  }

  .explainer-arrow {
    position: absolute;
    z-index: 6;
    background-position: center;
    opacity: 0;

    &.visible {
      opacity: 1;
      transition: opacity 0.2s;
    }
  }
</style>
